module.exports = __webpack_public_path__ + "static/media/podmurowka.8e60fcc0.pdf";